import EA from 'helpers/init';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default EA.Methods.horizontalScroll = ($this) => {
    const items = Array.from($this.querySelectorAll(':scope > .scroll-target'));
    if (!items.length) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const BASE   = reduced ? 0 : (parseFloat($this.dataset.speed) || 60);
    const FACTOR = parseFloat($this.dataset.factor) || 0.5;
    const MAX    = 2500;
    const DECAY  = 5;

    let loopWidth = 0;
    let offset    = 0;
    let boost     = 0;
    let wrap      = null;
    let setX      = null;

    const build = () => {
        $this.querySelectorAll('[data-clone]').forEach((n) => n.remove());

        gsap.set(items, { x: 0 });

        const first = items[0].getBoundingClientRect();
        const last  = items[items.length - 1].getBoundingClientRect();

        const spacing = items.length > 1
            ? items[1].getBoundingClientRect().left - first.right
            : parseFloat(getComputedStyle($this).columnGap) || 0;

        loopWidth = last.right - first.left + spacing;
        if (loopWidth <= 0) return;

        const sets = Math.ceil($this.clientWidth / loopWidth) + 1;

        for (let i = 0; i < sets; i++) {
            items.forEach((el) => {
                const clone = el.cloneNode(true);
                clone.setAttribute('data-clone', '');
                clone.setAttribute('aria-hidden', 'true');
                $this.appendChild(clone);
            });
        }

        setX   = gsap.quickSetter($this.children, 'x', 'px');
        wrap   = gsap.utils.wrap(-loopWidth, 0);
        offset = wrap(offset);
        setX(offset);
    };

    const st = ScrollTrigger.create({
        trigger: $this,
        start: 'top bottom',
        end:   'bottom top',
        onUpdate: (self) => {
            boost = gsap.utils.clamp(-MAX, MAX, self.getVelocity() * FACTOR);
        }
    });

    const tick = (time, delta) => {
        if (!setX || !loopWidth || !st.isActive) return;

        const dt = delta / 1000;

        offset -= (BASE + boost) * dt;
        setX(wrap(offset));

        boost *= Math.exp(-DECAY * dt);
    };

    const onRefresh = () => build();

    ScrollTrigger.addEventListener('refresh', onRefresh);
    build();
    gsap.ticker.add(tick);

    if (document.fonts) {
        document.fonts.ready.then(() => ScrollTrigger.refresh());
    }

    return () => {
        gsap.ticker.remove(tick);
        ScrollTrigger.removeEventListener('refresh', onRefresh);
        st.kill();
        $this.querySelectorAll('[data-clone]').forEach((n) => n.remove());
        gsap.set(items, { clearProps: 'transform' });
    };
};
